import { BodyText } from "@/components/ui/Text/BodyText";
import { Tooltip } from "@/components/ui/Tooltip/Tooltip";
import type { ReferenceRanges } from "@/types/observations";
import { OctagonAlert, TriangleAlert } from "lucide-react";

export const ReferenceRangeTooltip = ({
  referenceRanges = null,
  children,
  fallbackContent = "",
  contentClassName,
}: {
  referenceRanges: ReferenceRanges | null;
  children: React.ReactNode;
  fallbackContent: string;
  contentClassName?: string;
}) => {
  const renderTooltipContent = () => {
    if (!referenceRanges) {
      return fallbackContent;
    }
    return (
      <div className="flex flex-col gap-1">
        {referenceRanges.highRiskRange && (
          <div className="flex items-center gap-1.5">
            <div className="bg-white rounded-sm p-0.5 flex-shrink-0">
              <OctagonAlert
                className="h-3.5 w-3.5 stroke-error"
                aria-hidden="true"
              />
            </div>
            <BodyText className="text-white" size="sm">
              High: {referenceRanges.highRiskRange}
            </BodyText>
          </div>
        )}
        {referenceRanges.moderateConcernRange && (
          <div className="flex items-center gap-1.5">
            <div className="bg-white rounded-sm p-0.5 flex-shrink-0">
              <TriangleAlert
                className="h-3.5 w-3.5 stroke-warning"
                aria-hidden="true"
              />
            </div>
            <BodyText className="text-white" size="sm">
              Moderate: {referenceRanges.moderateConcernRange}
            </BodyText>
          </div>
        )}
        {referenceRanges.normalRange && (
          <BodyText className="text-white ml-6 pt-0.5" size="sm">
            Normal: {referenceRanges.normalRange}
          </BodyText>
        )}
      </div>
    );
  };

  return (
    <Tooltip
      tooltipContentText={!referenceRanges ? fallbackContent : undefined}
      tooltipContentComponent={
        referenceRanges ? renderTooltipContent() : undefined
      }
      triggerClassName="flex items-center gap-0.5"
      side="bottom"
      contentClassName={contentClassName}
    >
      {children}
    </Tooltip>
  );
};
